import format from 'date-fns/format';
import { getCellValue } from './cellData';
import DataTypes from '../dataTypes';

function parseCellValue(cellValue, column, formatDateConfig) {
  switch (column.dataType) {
    case DataTypes.Date:
      // console.log(cellValue,formatDateConfig)
      // return cellValue ? formatDate(cellValue) : '';
      return cellValue ? format(new Date(cellValue), formatDateConfig) : '';
    default:
      return cellValue;
  }
}

function setupTableData(
  rawData,
  columns,
  getObjectId,
  language,
  formatDateConfig
) {
  const data = [];

  // 1. Iterate data
  rawData.forEach(rawDataRow => {
    const row = {};

    // 2. Get id for row and store raw data
    row.id = getObjectId(rawDataRow);
    row.data = rawDataRow;

    // 3. Iterate columns
    let cellValue;
    columns.forEach(column => {
      // 4a. Get value for cell (using getCellValue)
      cellValue = getCellValue(rawDataRow, column, language);
      // 4b. Format date
      cellValue = parseCellValue(cellValue, column, formatDateConfig);
      // Store cell value with column name as key
      row[column.name] = cellValue;
    });
    // 5. Store in data array
    data.push(row);
  });

  return data;
}

// eslint-disable-next-line import/prefer-default-export
export { setupTableData };
